import { useState } from "react";
import styles from "./LoginForm.module.css";

var CryptoJS = require("crypto-js");
var config = require('./config.json');

async function login(username, password) {
    try {
        var encrypted = CryptoJS.AES.encrypt(password, config.encrypytSecret, { iv: config.encrypytSecret });
        const response = await fetch(
            'https://mayamayaapi2.azurewebsites.net/auth/login', 
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    email: username,
                    password: encrypted.toString(),
                }),
            }
        );

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error logging in:", error.message);
        return null;
    }
}

export default function LoginForm({ onLogin }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
  
    const handleSubmit = async (e) => {
        e.preventDefault();
        const data = await login(username, password);

        console.log(data);
        var org_code = "-1000";
        try {
            org_code = data.data.organizations[0].orgCode;
        } catch (e) {
            console.log("No organization code found");
        }
            
        if (data) {
          onLogin(data.data.token, org_code, username);
        } else {
          alert("Login failed. Please try again.");
        }
    };
  
    return (
      <div className={styles.LoginForm}>
        <a href="https://mayamaya.us/" className={styles.logo}>
            <img className={styles.imageHeader} src="https://lh3.googleusercontent.com/p/AF1QipNw2bHofJTC7JJ44GeZimwvI0G-o0uhSYrolVGL=s1360-w1360-h1020" alt="MayaMaya"></img>
        </a>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button type="submit">Login</button>
        </form>
        <p className={styles.message}>Use the login associated with your MayaMaya account</p>
      </div>
    );
}
